module.exports = __webpack_public_path__ + "static/img/money.954fffc7.svg";